<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
            <v-col cols="12">
                <v-card class="elevation-2">
                    <v-card-title>
                        Confronto Multi-Anno
                        <v-spacer />
                        <v-select v-model="anniSelezionati" :items="anniDisponibili" label="Seleziona anni" multiple
                            chips dense style="max-width: 300px;" @change="aggiornaConfrontoMultiAnno" />
                    </v-card-title>
                    <v-card-text>
                        <line-chart :data="graficoMultiAnno" :options="opzioniLinea" :key="keyMulti" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0 mt-3">
            <v-col cols="12" md="6">
                <v-card class="elevation-2">
                    <v-card-title>Variazione % Anno su Anno</v-card-title>
                    <v-card-text>
                        <bar-chart :data="graficoYoY" :options="opzioniBarre" :key="keyYoY" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="6">
                <v-card class="elevation-2">
                    <v-card-title>
                        Budget vs Consuntivo
                        <v-chip v-if="!budgetSalvato" x-small class="ml-2">proposto: anno precedente</v-chip>
                        <v-spacer />
                        <v-btn icon small @click="dialogBudget = true">
                            <v-icon small>settings</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <bar-chart :data="graficoBudget" :options="opzioniBarre" :key="keyBudget" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0 mt-3">
            <v-col cols="12">
                <v-card class="elevation-2">
                    <v-card-title>
                        Analisi Trimestrale
                        <v-spacer />
                        <span v-if="datiTrimestri.length && datiTrimestri[0].parziale"
                            class="text-caption text--secondary">
                            Anno in corso: confronto con lo stesso periodo del {{ filtri.anno - 1 }}
                        </span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="6">
                                <bar-chart :data="graficoTrimestri" :options="opzioniBarre" :key="keyTrim" />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>Trimestre</th>
                                                <th class="text-right">{{ filtri.anno }}</th>
                                                <th class="text-right">{{ filtri.anno - 1 }}</th>
                                                <th class="text-right">Var %</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(trim, i) in datiTrimestri" :key="i">
                                                <td>{{ trim.nome }}</td>
                                                <td class="text-right">{{ formattaValuta(trim.corrente) }}</td>
                                                <td class="text-right">{{ formattaValuta(trim.precedente) }}</td>
                                                <td class="text-right"
                                                    :class="trim.variazione >= 0 ? 'success--text' : 'error--text'">
                                                    {{ trim.variazione.toFixed(1) }}%
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!--         <v-row class="ma-0 pa-0 mt-3">
            <v-col cols="12">
                <v-card class="elevation-2">
                    <v-card-title>Confronto Performance Operatori</v-card-title>
                    <v-card-text>
                        <bar-chart :data="graficoOperatori" :options="opzioniBarre" :key="keyOper" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

        <!-- Dialog impostazione budget -->
        <v-dialog v-model="dialogBudget" max-width="600px">
            <v-card>
                <v-card-title>
                    Imposta Budget Mensile
                    <v-spacer />
                    <v-btn icon @click="dialogBudget = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="budgetAnnuale" label="Budget Annuale Totale" prefix="€" type="number"
                                outlined @input="calcolaBudgetMensile" />
                        </v-col>
                        <v-col cols="12" md="6" v-for="(mese, i) in budgetMensile" :key="i">
                            <v-text-field v-model="budgetMensile[i]" :label="getNomeMese(i)" prefix="€" type="number"
                                dense outlined />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogBudget = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salvaBudget">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { get_dati_grafico_mese, get_data, save_budget } from "@/api/api.documenti.js";
import LineChart from "@/components/chart/LineChart.js";
import BarChart from "@/components/chart/BarChart.js";
import mixinCharts from "@/components/chart/mixinCharts.js";

export default {
    name: "TabConfronti",

    components: {
        LineChart,
        BarChart
    },

    mixins: [mixinCharts],

    props: {
        filtri: { type: Object, default: () => ({}) },
        aggiornaDati: { type: Number, default: 0 }
    },

    data: () => ({
        anniSelezionati: [],
        anniDisponibili: [],

        graficoMultiAnno: {},
        graficoYoY: {},
        graficoBudget: {},
        graficoTrimestri: {},
        /* graficoOperatori: {}, */

        opzioniLinea: {},
        opzioniBarre: {},

        keyMulti: 0,
        keyYoY: 0,
        keyBudget: 0,
        keyTrim: 0,
        keyOper: 0,

        datiTrimestri: [],

        dialogBudget: false,
        budgetAnnuale: 0,
        budgetMensile: new Array(12).fill(0),
        budgetSalvato: false
    }),

    methods: {
        inizializzaAnni() {
            const annoCorrente = new Date().getFullYear();
            this.anniDisponibili = [];

            for (let i = 0; i < 5; i++) {
                this.anniDisponibili.push(annoCorrente - i);
            }

            this.anniSelezionati = [this.filtri.anno, this.filtri.anno - 1];
        },

        async aggiornaConfrontoMultiAnno() {
            if (this.anniSelezionati.length === 0) return;

            try {
                const mesi = this.$i2kFunctions.getShortMonths().map(m => m.charAt(0).toUpperCase() + m.slice(1));
                const colori = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'];

                const datasets = [];

                for (let i = 0; i < this.anniSelezionati.length; i++) {
                    const anno = this.anniSelezionati[i];
                    let filtriAnno = Object.assign({}, this.filtri);
                    filtriAnno.anno = anno;
                    filtriAnno.mese = -1;
                    filtriAnno.meseStr = "";

                    let res = await get_dati_grafico_mese(filtriAnno);

                    datasets.push({
                        label: anno.toString(),
                        data: res.data.datasets[0].data,
                        fill: false,
                        borderColor: colori[i % colori.length],
                        backgroundColor: colori[i % colori.length],
                        borderWidth: 2,
                        tension: 0.4,
                        pointRadius: 4,
                        pointHoverRadius: 6
                    });
                }

                this.graficoMultiAnno = {
                    labels: mesi,
                    datasets: datasets
                };

                this.keyMulti++;

            } catch (error) {
                console.error("Errore caricamento confronto multi-anno:", error);
            }
        },

        async caricaDatiYoY() {
            try {
                let res = await get_data("fatture/variazione-yoy", this.filtri);

                if (res && res.data) {
                    const etichette = res.data.map(d => `${d.annoCorrente} vs ${d.annoPrecedente}` + (d.parziale ? ' (stesso periodo)' : ''));
                    const variazioni = res.data.map(d => d.variazionePercentuale);

                    const colori = variazioni.map(v =>
                        v >= 0 ? 'rgba(76, 175, 80, 0.7)' : 'rgba(244, 67, 54, 0.7)'
                    );

                    this.graficoYoY = {
                        labels: etichette,
                        datasets: [{
                            label: 'Variazione %',
                            data: variazioni,
                            backgroundColor: colori,
                            borderWidth: 0
                        }]
                    };

                    this.keyYoY++;
                }

            } catch (error) {
                console.error("Errore caricamento YoY:", error);
            }
        },

        async caricaDatiBudget() {
            try {
                // Carica budget salvato
                let resBudget = await get_data("fatture/budget", this.filtri);

                if (resBudget && resBudget.data) {
                    this.budgetMensile = resBudget.data.budget;
                    this.budgetAnnuale = Math.round(this.budgetMensile.reduce((a, b) => a + b, 0) * 100) / 100;
                    this.budgetSalvato = resBudget.data.salvato;
                }

                // Carica consuntivo
                let filtriAnno = Object.assign({}, this.filtri);
                filtriAnno.anno = this.filtri.anno;
                filtriAnno.mese = -1;
                filtriAnno.meseStr = "";

                let resConsuntivo = await get_dati_grafico_mese(filtriAnno);

                const mesi = this.$i2kFunctions.getShortMonths().map(m => m.charAt(0).toUpperCase() + m.slice(1));

                this.graficoBudget = {
                    labels: mesi,
                    datasets: [
                        {
                            label: 'Budget',
                            data: this.budgetMensile,
                            backgroundColor: 'rgba(255, 152, 0, 0.5)',
                            borderColor: 'rgba(255, 152, 0, 1)',
                            borderWidth: 2
                        },
                        {
                            label: 'Consuntivo',
                            data: resConsuntivo.data.datasets[0].data,
                            backgroundColor: 'rgba(76, 175, 80, 0.5)',
                            borderColor: 'rgba(76, 175, 80, 1)',
                            borderWidth: 2
                        }
                    ]
                };

                this.keyBudget++;

            } catch (error) {
                console.error("Errore caricamento budget:", error);
            }
        },

        async caricaDatiTrimestri() {
            try {
                let res = await get_data("fatture/analisi-trimestri", this.filtri);

                if (res && res.data) {
                    this.datiTrimestri = res.data;

                    const etichette = res.data.map(t => t.nome);
                    const valoriCorrente = res.data.map(t => t.corrente);
                    const valoriPrecedente = res.data.map(t => t.precedente);

                    this.graficoTrimestri = {
                        labels: etichette,
                        datasets: [
                            {
                                label: this.filtri.anno.toString(),
                                data: valoriCorrente,
                                backgroundColor: 'rgba(33, 150, 243, 0.7)',
                                borderColor: 'rgba(33, 150, 243, 1)',
                                borderWidth: 2
                            },
                            {
                                label: (this.filtri.anno - 1).toString(),
                                data: valoriPrecedente,
                                backgroundColor: 'rgba(255, 152, 0, 0.7)',
                                borderColor: 'rgba(255, 152, 0, 1)',
                                borderWidth: 2
                            }
                        ]
                    };

                    this.keyTrim++;
                }

            } catch (error) {
                console.error("Errore caricamento trimestri:", error);
            }
        },

        /* async caricaDatiOperatori() {
            try {
                let res = await get_data("fatture/performance-operatori", this.filtri);

                if (res && res.data) {
                    const operatori = res.data.map(o => o.nome);
                    const fatturato = res.data.map(o => o.fatturato);

                    this.graficoOperatori = {
                        labels: operatori,
                        datasets: [{
                            label: 'Fatturato per Operatore',
                            data: fatturato,
                            backgroundColor: 'rgba(156, 39, 176, 0.7)',
                            borderColor: 'rgba(156, 39, 176, 1)',
                            borderWidth: 2
                        }]
                    };

                    this.keyOper++;
                }

            } catch (error) {
                console.error("Errore caricamento operatori:", error);
            }
        }, */

        calcolaBudgetMensile() {
            const budgetMensile = Math.round(Number(this.budgetAnnuale) / 12 * 100) / 100;
            this.budgetMensile = new Array(12).fill(budgetMensile);
        },

        async salvaBudget() {
            try {
                // I campi di testo restituiscono stringhe: li converto in numeri prima dell'invio
                const importi = this.budgetMensile.map(v => Number(v) || 0);

                if (importi.some(v => v < 0)) {
                    this.$toast.alert("Gli importi del budget non possono essere negativi");
                    return;
                }

                await save_budget({
                    anno: this.filtri.anno,
                    budget: importi
                });

                this.$toast.success("Budget salvato con successo");
                this.dialogBudget = false;
                this.caricaDatiBudget();
                this.$emit('budgetSalvato');

            } catch (error) {
                console.error("Errore salvataggio budget:", error);
                this.$toast.error("Errore durante il salvataggio");
            }
        },

        getNomeMese(indice) {
            const mesi = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
                'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
            return mesi[indice];
        },

        formattaValuta(valore) {
            return '€ ' + this.$functions.numberWithCommas(valore.toFixed(2));
        },

        caricaTuttiDati() {
            this.aggiornaConfrontoMultiAnno();
            this.caricaDatiYoY();
            this.caricaDatiBudget();
            this.caricaDatiTrimestri();
            /* this.caricaDatiOperatori(); */
        }
    },

    mounted() {
        this.opzioniLinea = this.getOptionsMixedChart();
        this.opzioniBarre = this.getOptionsMixedChart();
        this.inizializzaAnni();
        this.caricaTuttiDati();
    },

    watch: {
        aggiornaDati() {
            this.caricaTuttiDati();
        }
    }
}
</script>